import { z } from 'zod';
import { isMongoId } from '../../helpers';
import CalendarDay from '../../../utils/calendar-day';

export const CreateWithdrawalUploadFileInput = z.object({
  firmId: z.string().refine(isMongoId()),
  withdrawalDate: z.instanceof(CalendarDay).optional(),
  trancheIds: z.array(z.string().refine(isMongoId())).optional(),
});

export const WithdrawalRowDataInput = z.object({
  systemInvestorId: z.union([z.string(), z.number()]),
  netWithdrawalAmount: z.union([z.string(), z.number()]),
  withdrawalAmount: z.union([z.string(), z.number()]).optional(),
  withdrawalDate: z.instanceof(CalendarDay),
  withdrawalFee: z.union([z.string(), z.number()]).optional(),
  notes: z.string().optional(),
  exportStatus: z.string(),
});

export const ValidateBulkWithdrawalsInput = z.object({
  withdrawals: z.array(WithdrawalRowDataInput).min(1),
  firmId: z.string().refine(isMongoId()),
});

export const ValidateIndividualWithdrawalInput = z.object({
  investorId: z.string().refine(isMongoId()),
  firmId: z.string().refine(isMongoId()),
  amount: z.number(),
  withdrawalDate: z.instanceof(CalendarDay),
  withdrawalFee: z.number().optional(),
});

export const DeleteWithdrawalInput = z.object({
  withdrawalId: z.string().refine(isMongoId()),
});

export const DeleteBulkUploadInput = z.object({
  withdrawalId: z.string().refine(isMongoId()),
});

export const DownloadBulkUploadFileInput = z.object({
  withdrawalId: z.string().refine(isMongoId()),
});

export const FileBase64Response = z.object({
  fileBase64: z.string(),
  filename: z.string(),
});
